/**
 * 在浏览器空闲时间执行某些非关键任务
 * params @task - 任务函数 @timeout - 队列任务执行超时时间，默认为500毫秒
 */
export default function () {
  type IdleTask = () => void;
  const idleQueue: IdleTask[] = [];
  let isRunning = false;

  // 添加任务到队列
  function queueIdleTask(task: IdleTask, timeout = 500) {
    idleQueue.push(task);
    runIdleQueue(timeout);
  }

  // 运行队列
  function runIdleQueue(timeout: number) {
    if (isRunning || idleQueue.length === 0) return;
    isRunning = true;
    const callback = (deadline: IdleDeadline) => {
      // 循环执行任务，直到没有剩余时间或任务队列为空
      while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && idleQueue.length > 0) {
        const task = idleQueue.shift();
        task?.();
      }

      isRunning = false;
      // 如果任务队列不为空，则继续执行队列中的任务
      if (idleQueue.length > 0) {
        runIdleQueue(timeout);
      }
    };
    // 使用requestIdleCallback执行任务
    if ('requestIdleCallback' in window) {
      requestIdleCallback(callback, { timeout });
    } else {
      // 如果不支持requestIdleCallback，则使用setTimeout模拟
      setTimeout(() => callback({ timeRemaining: () => 50, didTimeout: true }), timeout);
    }
  }
  return {
    queueIdleTask
  };
}
